import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://it.trustpilot.com/review/wikicasa.it",
  target: "_blank",
  rel: "noopener"
}, "Trustpilot", -1 /* HOISTED */);
var _hoisted_2 = [_hoisted_1];
import { onMounted } from "vue";
//@ts-ignore
import { injectScriptTag } from "@utils/DOMUtils";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'TrustpilotMicrostar',
  setup(__props) {
    onMounted(() => {
      //Trustpilot script
      injectScriptTag({
        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" Trustpilot widget "), _createElementVNode("div", {
        class: _normalizeClass(["trustpilot-widget tw-mt-25px", _ctx.$attrs['class']]),
        "data-locale": "it-IT",
        "data-template-id": "5419b732fbfb950b10de65e5",
        "data-businessunit-id": "6009f6cc7a6379000142e2e2",
        "data-style-height": "24px",
        "data-style-width": "100%",
        "data-theme": "light"
      }, _hoisted_2, 2 /* CLASS */)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */);
    };
  }
}));